import { createContext, useState, ReactNode } from 'react';
import { NewAppVersionModal } from './new-app-version-modal';

export const NewAppVersionContext = createContext({
  showNewAppVersionModal: false,
  newAppVersionModalEnabled: () => {},
});

interface NewAppVersionProviderProps {
  children: ReactNode;
}
export const NewAppVersionProvider = ({ children }: NewAppVersionProviderProps) => {
  const [showNewAppVersionModal, newAppVersionModalEnabled] = useState(false);
  return (
    <NewAppVersionContext.Provider
      value={{
        showNewAppVersionModal,
        newAppVersionModalEnabled: () => newAppVersionModalEnabled(true),
      }}
    >
      <>
        {children}
        {showNewAppVersionModal && <NewAppVersionModal />}
      </>
    </NewAppVersionContext.Provider>
  );
};
